<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form custom-wyq">
        <div class="tip">
          <i class="el-icon-warning"></i>请使用手机浏览器扫码下载
        </div>
        <div ref="qrcode" id="qrcode" class="qr-code"></div>
        <div>
          <el-button type="primary" @click="downloadQr()">下载二维码</el-button>
        </div>
      </div>
    </template>
  </DialogContainer>
</template>
<script>
import DialogContainer from "@/components/Dialog.vue";

import QRCode from "qrcodejs2";
export default {
  name: "AddOrEdit",
  data() {
    return {
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "扫二维码下载",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      qrUrl: "",
      qrcode: null,
    };
  },
  components: {
    DialogContainer,
  },
  methods: {
    downloadQr() {
      // 获取二维码的 canvas 元素
      const canvas = document.querySelector("#qrcode canvas");
      if (canvas) {
        // 将 canvas 转换为图片 URL
        const url = canvas.toDataURL("image/png");
        // 创建一个链接元素
        const link = document.createElement("a");
        link.href = url;
        link.download = "qrcode.png"; // 下载的文件名
        link.click(); // 触发下载
      }
    },
    generateQRCode() {
      // 获取DOM元素
      const qrcodeContainer = this.$refs.qrcode;
      // 创建二维码实例
      this.qrcode = new QRCode(qrcodeContainer, {
        text: this.qrUrl,
        width: 300,
        height: 300,
      });
    },
    init(row) {
      if (this.qrcode) {
        this.qrcode.clear();
        this.$refs.qrcode.innerHTML = "";
      }
      this.dialogObj.show = true;
      this.qrUrl =
        process.env.VUE_APP_BASE_PATH +
        "/pmy/file/sys-file/download?fileId=" +
        row.fileId;
      this.$nextTick(() => this.generateQRCode());
    },
  },
};
</script>

<style scoped lang="scss">
.custom-wyq {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .tip {
    display: flex;
    align-items: center;
    font-size: 20px;
    i {
      font-size: 24px;
      margin-right: 2px;
      color: #cf9236;
    }
  }
  .qr-code {
    margin: 40px;
  }
}
</style>
